import {useEffect, useState} from "react";
import {Paper, TextField} from "@mui/material";
import AddLeadSupervisor from "./leadSupervisor/AddLeadSupervisor";
import {useGetLeadSupervisorsQuery} from "../../services/authService";
import {DISPATCH_TYPES} from "../../utils/constants";
import {CustomAutocomplete} from "../../style/mui/customStyle";
import sxAutocomplete from "../../style/sxAutocompleteStyles";
import EditLeadSupervisor from "./leadSupervisor/EditLeadSupervisor";
import DeleteLeadSupervisor from "./leadSupervisor/DeleteLeadSupervisor";

const LeadSupervisor = ({ name, onUpdate, dispatchCallback, placeholder = 'Lead Supervisor' }) => {
    const [filter, setFilter] = useState(null);
    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [addDialogOpen, setAddDialogOpen] = useState(false);
    const [open, setOpen] = useState(false);

    const {data, isFetching } = useGetLeadSupervisorsQuery(filter, { skip: filter === null });

    const handleChange = (event, value) => {
        if(value){
            dispatchCallback(DISPATCH_TYPES.leadSupervisor, value);
            setSelectedOption(value);
        } else {
            dispatchCallback(DISPATCH_TYPES.leadSupervisor, null);
            setOpen(true);
        }
    };

    const handleInputChange = (event, value) => {
        if(value === '') {
            setSelectedOption(null);
            setFilter('');
        } else {
            setFilter(value);
        }
    }

    useEffect(() => {
        if(name){
            setFilter(name);
        }
    }, [name]);

    useEffect(() => {
        if(data){
            setOptions(data?.leadSupervisors);
            let selOption = data?.leadSupervisors?.find(option => option.fullName === filter);
            setSelectedOption(selOption ?? null);
            dispatchCallback(DISPATCH_TYPES.leadSupervisor, selOption);
        }
    }, [data, filter]);

    const openAddDialog = () => {
        setAddDialogOpen(true);
    }

    const closeAddDialog = () => {
        setAddDialogOpen(false);
    }

    const AddNewLeadSupervisor = ({ children, ...other }) => (
        <Paper {...other}>
            {children}
            <div
                className="bg-secondary text-white cursor-pointer p-2 common-text"
                onMouseDown={(event) => {
                    event.preventDefault();
                    openAddDialog();
                }}
            >
                +Add Lead Supervisor
            </div>
        </Paper>
    );
    const handleOpen = () => {
        if(!selectedOption){
            setSelectedOption(null);
            setFilter('');
        }       
        setOpen(true);
    }

    const setSupervisor = (fullName) => {
        setFilter(fullName);
    }

    return (
        <div className="d-flex align-items-center">
            <CustomAutocomplete
                // id="lead-supervisor-list"
                className="flex-grow-1"
                sx={sxAutocomplete}
                loading={isFetching}
                onChange={handleChange}
                onInputChange={handleInputChange}
                open={open}
                onOpen={() => handleOpen()}
                onClose={() => setOpen(false)}
                options={options || []}
                value={selectedOption}
                filterOptions={(x) => x}
                renderOption={(props, option) => (
                    <li {...props} key={option.id}>
                        <span className="autocomplete-option-label">{option.fullName || ''}</span>
                    </li>
                )}
                getOptionLabel={(option) => (option ? option.fullName || '' : '')}
                // isOptionEqualToValue ={(option, value) => option?.id === value?.id}
                noOptionsText="Lead Supervisor not found"
                renderInput={(params) => (
                    <TextField {...params}
                       label={
                           <label className="autocomplete-input-label">{placeholder}</label>
                       }
                       variant="outlined"
                    />
                )}
                PaperComponent={AddNewLeadSupervisor}
            />

            <div className={`flex-shrink-0 ps-2 ${!selectedOption && 'pe-none opacity-50'}`}>
                <EditLeadSupervisor
                    supervisor={selectedOption}
                    // setSupervisor={setSelectedOption}
                    setSupervisor={setSupervisor}
                    onUpdate={onUpdate}
                />

                <DeleteLeadSupervisor
                    supervisor={selectedOption}
                    setSupervisor={setSelectedOption}
                    onDelete={onUpdate}
                />
            </div>

            <AddLeadSupervisor
                isOpen={addDialogOpen}
                onAdd={onUpdate}
                onCancel={closeAddDialog}
                setFilter={setFilter}
                setSupervisor={setSupervisor}                
            />
        </div>
    )
}

export default LeadSupervisor;
